const host = 'https://wxsky.com' // 主站
const baseURL = host + '/flyCube.php'
const listPath = host + '/Data/UploadFiles/category/'// 分类列表图标
const bannerPath = host + '/Data/UploadFiles/banner/'// 轮播图路径
const spuPath = host + '/Data/UploadFiles/spu/'// spu图
const skuPath = host + '/Data/UploadFiles/sku/' // sku图
const logoPath = host + '/Data/UploadFiles/logo/' // 商铺图标
const photoPath = host + '/Data/UploadFiles/photo/'// 管理员图标
const avatarsPath = host + '/Public/images/appAvatars/' // 小程序游客头像
const sitePath = host + '/Data/UploadFiles/site/'// 站点图片
const qrPath = host + '/Data/UploadFiles/qr/' // 菊花码 路径
const tempPath = host + '/Data/UploadFiles/temp/' // 临时图片路径
const homeButtonPath = host + '/Data/UploadFiles/home-buttons/' // 首页按钮图片
export default {

  /**
   * @description: 全局title
   */
  title: '送餐系统',
  appName: '魔方物流控制系统',
  appVersion: 'v2.7.7-release',
  appDescription: '用于无人机送餐任务监管、订单处理、飞机控制、日志查看和日终处理。',

  /**
   * @description: api服务器
   * host 主站
   * api接口地址
   * 分类图标 路径
   * spu图 路径
   * sku图 路径
   * 商铺图标 路径
   * 管理员头像 路径
   * 小程序游客头像 路径
   * 菊花码图片 路径
   * 临时图片 路径
   * api飞机控制终端接口路径
   * api小程序后台接口路径
   * api登录接口路径
   */
  host: host,
  baseURL: baseURL,
  listPath: listPath,
  bannerPath: bannerPath,
  spuPath: spuPath,
  skuPath: skuPath,
  logoPath: logoPath,
  photoPath: photoPath,
  avatarsPath: avatarsPath,
  sitePath: sitePath,
  qrPath: qrPath,
  tempPath: tempPath,
  homeButtonPath,
  apiPlanePath: '/mpApi/Plane/',
  apiAdminPath: '/mpApi/Admin/',
  apiGodPath: '/mpApi/God/',
  qweatherHost: 'mt564wjtkb.re.qweatherapi.com',
  qweatherApiKey: '47ac57353113496d9b713e46534d82e3',
  weatherCacheMinutes: 15,
  apiPayPath: '/mpApi/Pay/',
  apiLoginPath: '/mpApi/Login/',
  apiAppPath: '/mpApi/App/',
  /**
   * @description: mqtt服务器
   * mqttHost 地址
   * mqttPort 端口
   */
  mqttHost: 'wss://wxsky.com',
  mqttPort: 58083
}
